import React from 'react'
import styled from 'styled-components'
import { Row, Col } from 'antd'
import { useTranslation } from 'react-i18next'
import EducationList from '../EducationList'

const Education = () => {

    const {t} = useTranslation()

    return (
        <>
            <Container>
                <Row justify='center'>
                    <Col>
                        <h2>{t('Educacao')}</h2>
                    </Col>
                </Row>
                <Row justify='center' style={{width: '100%', padding: '30px 0'}}>
                    <EducationList displayed={3} col={6}/>
                </Row>
            </Container>
        </>
    )
}

export default Education;

const Container = styled.div`
    background-color: #f0f2f5;
    & *{
        color: #010008;
        font-family: 'Share Tech Mono', monospace;
    }
    & h2 {
        font-size: 30px;
    }
`